import { useMutation } from '@tanstack/react-query';
import { PermissionsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function usePermissionsControllerUpdatePermissionMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['permissionsControllerUpdatePermission', accessControlScope],
        mutationFn: async (args) => {
            const api = new PermissionsApi(accessControlConfig);
            return api.permissionsControllerUpdatePermission(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=usePermissionsControllerUpdatePermissionMutation.js.map